import l from "./component-library142.js";
/* empty css                     */
import i from "./component-library98.js";
var c = function() {
  var a = this, t = a._self._c, s = a._self._setupProxy;
  return t("nav", { staticClass: "breadcrumb", class: s.containerClass, attrs: { "aria-label": "Du bist hier:" } }, [t("ul", { staticClass: "breadcrumb__list" }, a._l(s.fullItems, function(r, e) {
    return t("li", { key: e, staticClass: "breadcrumb__element" }, [r.to ? t(s.LinkButton, { staticClass: "breadcrumb__link", class: { "breadcrumb__link--is-active": s.isActive(e) }, attrs: { "tealium-type": "context.text.breadcrumb", to: r.to, tag: "nuxt-link", exact: "", label: r.label, "no-styling": "" } }) : t("span", { staticClass: "breadcrumb__link", class: { "breadcrumb__link--is-active": s.isActive(e) } }, [a._v(" " + a._s(r.label) + " ")]), s.isActive(e) ? a._e() : t("span", { staticClass: "breadcrumb__element-separator", attrs: { "aria-hidden": "true" } }, [a._v("·")])], 1);
  }), 0), a.withBrodos ? t("span", { staticClass: "breadcrumb__element breadcrumb__brodos-claim" }, [a._v(" In Kooperation mit "), t(s.BrodosLogo, { staticClass: "breadcrumb__brodos-claim-logo", attrs: { height: 12, width: 51, "aria-label": "Brodos" } })], 1) : a._e(), t("script", { attrs: { type: "application/ld+json" } }, [a._v(" " + a._s(s.jsonLD) + " ")])]);
}, _ = [], o = /* @__PURE__ */ i(
  l,
  c,
  _,
  !1,
  null,
  "4e20abda"
);
const d = o.exports;
export {
  d as default
};
